export const MESSAGES = {
  ASSIGNED_RISK_APPLICATION: {
    DEFAULT_NAME: 'Assigned risk application',
    UNKNOWN_STATUS: 'Unknown',
    NOT_FOUND: 'Assigned Risk application could not be found.',
    APPLICATIONS_SECTION_TITLE: 'Assigned risk applications',
    ACTIONS: {
      ACCEPT: 'Accept',
      PEND: 'Pend',
      DECLINE: 'Decline',
      MOVE: 'Move application',
    },
    TABS: {
      COVERAGE_INFORMATION: 'Coverage information',
      APPLICATION_DETAILS: 'Application details',
      NAMES_AND_ADDRESSES: 'Names & addresses',
      PREMIUMS: 'Premiums',
      INSURANCE_HISTORY: 'Insurance history',
      DOCUMENTS: 'Documents',
      ERROR_SUMMARY: 'Error summary',
      AGENT_DETAILS: 'Agent details',
      HISTORY: 'History',
    },
    TAB_UNAVAILABLE: (label: string) => `${label} is not available yet.`,
    COVERAGE_INFORMATION: {
      TITLE: 'Coverage information',
      COMBO_ID_LABEL: 'Combo ID',
      COVERAGE_ID_LABEL: 'Coverage ID',
      FEIN_LABEL: 'FEIN',
      COVERAGE_NAME_LABEL: 'Coverage Name',
      DOING_BUSINESS_AS_LABEL: 'Doing Business As',
      LEGAL_STATUS_LABEL: 'Legal Status',
      YEARS_IN_BUSINESS_LABEL: 'Years in Business',
      LEGAL_STATUS_OTHER_LABEL: 'Legal Status Other',
      BUSINESS_OPERATIONS_LABEL: 'Description of Business and Operations',
      CONTACT_TITLE: 'Contact information',
      MAILING_ADDRESS_LABEL: 'Mailing Address',
      AREA_LABEL: 'Area',
      COUNTRY_LABEL: 'Country',
      PHONE_LABEL: 'Phone Number',
      EMAIL_LABEL: 'Email',
      OWNERS_TITLE: 'Owners',
      OWNER_HEADERS: ['Name', 'Title', 'Coverage', 'Salary', '% Ownership', 'Birth Date', 'Class Code', 'Duties'],
      NO_OWNERS: 'No owners available.',
      LOAD_ERROR: 'Unable to load coverage information.',
      NOT_FOUND: 'Coverage information could not be found.',
      ACCEPT: 'Accept',
      REJECT: 'Reject',
    },
    AGENT_DETAILS: {
      TITLE: 'Agent details',
      LOAD_ERROR: 'Unable to load agent details.',
      FIELD_LABELS: {
        NAME: 'Name',
        EMAIL: 'Email address',
        AGENCY: 'Agency',
        ADDRESS: 'Address',
        PHONE: 'Phone number',
        FEIN: 'FEIN',
      },
    },
    APPLICATION_DETAILS: {
      TITLE: 'Application details',
      LOAD_ERROR: 'Unable to load application details.',
      NOT_FOUND: 'Assigned Risk application details could not be found.',
      AGENT_NOTES_TITLE: 'Agent notes',
      COVERAGE_HISTORY_TITLE: "Workers' compensation coverage history",
      QUESTIONS: {
        PREVIOUS_COVERAGE_NC: 'Previous coverage in North Carolina?',
        PREVIOUS_COVERAGE_OTHER_STATE: 'Previous coverage in any other state?',
        UNPAID_PREMIUMS_DISPUTE: 'Are there any unpaid premiums in dispute?',
        QUALIFYING_CHANGE: 'Have any of the following occurred within the last 5 years?',
        USES_SUBCONTRACTORS: 'Uses subcontractors?',
        LEASES_WORKERS: 'Leases employees to or from another organization?',
        TRUCKING_CLASSIFICATIONS: 'Trucking classifications apply?',
        OPERATIONS_OTHER_STATES: 'Operations in states other than North Carolina?',
        LISTED_STATES: 'Requesting coverage for listed states?',
      },
      QUALIFYING_CHANGE_ITEMS: [
        'Ownership of 50% or more with another entity',
        'Name change',
        'Consolidation or merger',
        'Ownership change of any kind',
      ],
    },
    NAMES_AND_ADDRESSES: {
      TITLE: 'Names & addresses',
      LOAD_ERROR: 'Unable to load names and addresses.',
      ADDRESS_HEADER: 'Address',
      NAME_HEADER: 'Name',
      PRIMARY: 'Primary',
      EXPAND_ADDRESSES: 'Expand addresses for',
      COLLAPSE_ADDRESSES: 'Collapse addresses for',
    },
    INSURANCE_HISTORY: {
      TITLE: 'Insurance history',
      LOAD_ERROR: 'Unable to load insurance history.',
      TABLE_HEADERS: {
        CARRIER_NAME: 'Carrier Name',
        STATE: 'State',
        POLICY_NUMBER: 'Policy #',
        FROM: 'From',
        TO: 'To',
        ANNUAL_PREMIUM: 'Annual Premium',
      },
    },
  },
  CLASS_CODE: {
    INVALID_TOOLTIP: 'Invalid code',
  },
  POLICY: {
    CARRIER_PROFILE: {
      TITLE: 'Carrier profile',
      NAME_LABEL: 'Carrier name',
      ID_LABEL: 'Carrier ID',
      EMPTY_STATE: 'Carrier information unavailable',
      MISSING_ID: 'N/A',
      PAM_TITLE: 'Primary access manager (PAM)',
      CONTACTS_TITLE: 'Contacts',
      ROLE_LABEL: 'Role',
      CONTACT_NAME_LABEL: 'Contact name',
      EMAIL_LABEL: 'Email address',
      PHONE_LABEL: 'Phone number',
      NO_PAM_STATE: 'Primary Access Manager unavailable',
      NO_CONTACTS_STATE: 'No carrier contacts available',
      MOCK_LABEL: 'Mock',
    },
    MOVE_MODAL: {
      EXISTING_COVERAGE_AND_COMBO_LABEL: 'Move to an existing coverage and combo.',
      NEW_COVERAGE_IN_EXISTING_COMBO_LABEL: 'Move to a new coverage in an existing combo.',
      NEW_COVERAGE_AND_COMBO_LABEL: 'Move to a new coverage and combo.',
      USE_LINKED_COMBO_LABEL: 'Use currently linked combo',
      REASON_LABEL: 'Why is this action being taken?',
    },
  },
  COVERAGE: {
    MOVE_MODAL: {
      EXISTING_COMBO_LABEL: 'Move to an existing combo.',
      NEW_COMBO_LABEL: 'Move to a new combo.',
      SUCCESS_TOAST: 'Coverage and all policies were successfully moved.',
      REASON_LABEL: 'Why is this action being taken?',
    },
  },
  TRANSACTION_HISTORY: {
    TRANSACTION_STATUS: {
      REJECTED: 'Rejected',
    },
    DETAIL_VALUE_UNKNOWN: 'Unknown',
  },
} as const;
